module.exports = __webpack_public_path__ + "img/learning-1.6443b63c.png";